import { render, staticRenderFns } from "./AssessmentWizard.vue?vue&type=template&id=326ae2e4&scoped=true"
import script from "./AssessmentWizard.vue?vue&type=script&lang=js"
export * from "./AssessmentWizard.vue?vue&type=script&lang=js"
import style0 from "./AssessmentWizard.vue?vue&type=style&index=0&id=326ae2e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326ae2e4",
  null
  
)

export default component.exports